<template>
  <div>
    <BarChart ref="barChartRef" v-bind="barChartProps" />

    <!-- <v-btn
        v-if="isAdmin"
        small
        color="primary"
        @click="logChart"
    >
      Log Chart
    </v-btn> -->
  </div>
</template>

<script>
import { BarChart, useBarChart } from "vue-chart-3";
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "Chart3",
  components: { BarChart },
  computed: {
    isAdmin() {
      const role = this.$store.state.profile?.user?.role;
      return role === 'Admin' || role === 'admin' || role === 'srAdmin';
    }
  },
  props: {
    chartData: Object,
    options: Object,
  },
  setup(props) {
    const { barChartProps, barChartRef } = useBarChart({
      chartData: props.chartData,
      options: props.options,
      height: 500,
    });
    const logChart = () => {
      try {
        const chart = barChartRef.value?.chart;

        if (!chart) {
          console.warn("[Chart3] Chart.js instance non prête");
          console.log(barChartRef.value);
          return;
        }

        console.log("=== Chart.js instance ===");
        console.log(chart);
        console.log("chart.data:", chart.data);
        console.log("chart.options:", chart.options);
        console.log("chart.scales:", chart.scales);
        console.log("chart.config:", chart.config);
      } catch (e) {
        console.error("[Chart3] logChart error:", e);
      }
    };

    return {
      barChartProps,
      barChartRef,
      logChart,
    };
  },
});
</script>